export enum ProductLine {
    LETS_PLAY= "LETS_PLAY",
    LETS_READ = "LETS_READ",
    PLAY_ALONG = "PLAY_ALONG",
    SING_ALONG = "SING_ALONG",
    STEP_BY_STEP = "STEP_BY_STEP",
    STRAIGHT_PLAY = "STRAIGHT_PLAY",
    READ_ALONG  = "READ_ALONG",

    LETS_PLAY_TEASER  = "LETS_PLAY_TEASER",
    STRAIGHT_PLAY_TEASER  = "STRAIGHT_PLAY_TEASER",
    STEP_BY_STEP_TEASER  = "STEP_BY_STEP_TEASER",

    PLAY_ALONG_AUDIO  = "PLAY_ALONG_AUDIO",
    SING_ALONG_AUDIO  = "SING_ALONG_AUDIO",
    SING_ALONG_SPOKEN_WORD_AUDIO  = "SING_ALONG_SPOKEN_WORD_AUDIO",
    STORIES_AND_SONGS_AUDIO  = "STORIES_AND_SONGS_AUDIO",
    BEDTIME_REVIEW  = "BEDTIME_REVIEW",
    BEDTIME_REVIEW_AUDIO  = "BEDTIME_REVIEW_AUDIO",
    LISTEN_ALONG_AUDIO  = "LISTEN_ALONG_AUDIO",

    ENGLISH_TAB  = "ENGLISH_TAB"
}